import { Hotel } from 'tokyu-hooks'
import { HOTEL_OPTION_ALL, toPlanListItem } from '../../../core/bookings'

export const QUERY_HOTEL_PLAN_LIST_KEY = 'QUERY_HOTEL_PLAN_LIST_KEY'
export const QUERY_HOTEL_PLAN_RESALE_LIST_KEY =
  'QUERY_HOTEL_PLAN_RESALE_LIST_KEY'

export const fetchHotelPlans =
  (clientSession: string, _?: string) =>
  async ({ queryKey }: { queryKey: any[] }) => {
    const [_key, { hotelCode, locale, hotelPlanCodes }] = queryKey

    const res =
      hotelCode === HOTEL_OPTION_ALL
        ? await Hotel.listPlans({
            baseUrl: process.env.NEXT_PUBLIC_TRIPLA_BASE_URL as string,
            clientSession: clientSession,
            hotelBrand: process.env.NEXT_PUBLIC_TRIPLA_HOTEL_BRAND as string,
            locale,
            hotel_plan_codes: hotelPlanCodes,
          })
        : await Hotel.listHotelPlans({
            baseUrl: process.env.NEXT_PUBLIC_TRIPLA_BASE_URL as string,
            clientSession: clientSession,
            hotelCode,
            locale,
            hotel_plan_codes: hotelPlanCodes,
          })

    return res?.data?.data?.map(toPlanListItem) || null
  }
